import { render, staticRenderFns } from "./Fund.vue?vue&type=template&id=fa195b72&scoped=true"
import script from "./Fund.vue?vue&type=script&lang=js"
export * from "./Fund.vue?vue&type=script&lang=js"
import style0 from "./Fund.vue?vue&type=style&index=0&id=fa195b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa195b72",
  null
  
)

export default component.exports